import { render } from "./PrimaryView.vue?vue&type=template&id=0c5ad544"
import script from "./PrimaryView.vue?vue&type=script&lang=js"
export * from "./PrimaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__